export { monitorForExternal, dropTargetForExternal } from '../../adapter/external-adapter';

// The data that is being dragged